import * as Yup from "yup";

export const validationsForConfiguration = Yup.object().shape({
  appVersion: Yup.string().trim().required("App version is required"), //1
  changeNav: Yup.number() //2
    .typeError("Must be a number")
    .required("ChangeNav is required"),
  crmCurrentCampaign: Yup.string() //3
    .trim()
    .required("CRM Current Campaign is required"),
  cutOfShareClassDate: Yup.date() //4
    .typeError("Enter a valid date (YYYY-MM-DD)")
    .required("Cut Off Share Class Date is required"),
  nav: Yup.number() //5
    .typeError("NAV Must be a number")
    .required("Nav is required"),
  hmInvestorCnt: Yup.number() //6
    .typeError("HM Investor Count Must be a number")
    .required("HM Investor Count is required"),
  ARFGroceryChains: Yup.string()
    .trim()
    .required("ARF Grocery Chains is required"), //7
});
